export class InvalidArgumentException extends Error {
  constructor(private field: string, private reason: 'required' | 'invalid') {
    super(`Invalid argument: ${field} - ${reason}`);
  }

  getErrorDetails() {
    return {
      field: this.field,
      reason: this.reason,
    };
  }
}
